var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 10.834H1C0.45 10.834 0 10.384 0 9.83398V1.83398C0 1.28398 0.45 0.833984 1 0.833984H7C7.55 0.833984 8 1.28398 8 1.83398V9.83398C8 10.384 7.55 10.834 7 10.834ZM16 10.834H12V16.834H16V10.834ZM1 18.834H7C7.55 18.834 8 18.384 8 17.834V13.834C8 13.284 7.55 12.834 7 12.834H1C0.45 12.834 0 13.284 0 13.834V17.834C0 18.384 0.45 18.834 1 18.834ZM6 16.834V14.834H2V16.834H6ZM11 18.834H17C17.55 18.834 18 18.384 18 17.834V9.83398C18 9.28398 17.55 8.83398 17 8.83398H11C10.45 8.83398 10 9.28398 10 9.83398V17.834C10 18.384 10.45 18.834 11 18.834ZM6 8.83398V2.83398H2V8.83398H6ZM10 1.83398V5.83398C10 6.38398 10.45 6.83398 11 6.83398H17C17.55 6.83398 18 6.38398 18 5.83398V1.83398C18 1.28398 17.55 0.833984 17 0.833984H11C10.45 0.833984 10 1.28398 10 1.83398ZM16 4.83398V2.83398H12V4.83398H16Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.d3b8854ea5479b3479ba66b731156a6c.svg";
export { ForwardRef as ReactComponent };